import type { ActivatedRoute } from '@angular/router'

export function getArticleIdFromRoute(route: ActivatedRoute): number | null {
  for (const currentRoute of [...route.pathFromRoot].reverse()) {
    const articleId = currentRoute.snapshot.paramMap.get('id')

    if (!articleId) {
      continue
    }

    const parsedArticleId = parseInt(articleId, 10)

    if (!isNaN(parsedArticleId)) {
      return parsedArticleId
    }
  }

  return null
}
